// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__131dE","colCheckbox":"styles_colCheckbox__1OUNy"};